import siFetch from "api/fetch";

import handleParams from "api/handle-params";

const self = (params, init = null) =>
  siFetch(`/api/v1/campaign/report${handleParams(params)}`, init);

export default self;
